// import React from "react";
// import Header from "../shared/Header";
// import Sidebar from "../shared/Sidebar";
// import "../index.css";

// const Layout = ({ component }) => {
//   return (
//     <>
//       <div
//         className=" bg-secondary w-full"
//         style={{
//           background:
//             "linear-gradient(180deg, rgba(2, 0, 40, 1) 0%, rgba(1, 0, 75, 1) 49%, rgba(2, 0, 95, 1) 65%, rgba(2, 0, 120, 1) 100%)",
//         }}
//       >
//         <div className="sticky z-50 top-0">
//           <Header />
//         </div>
//         <div className="flex justify-between bg-secondary">
//           <div
//             className="!z-30 text-black shadow-card !opacity-80 shadow-red-500"
//             style={{ width: "18%" }}
//           >
//             <Sidebar />
//           </div>
//           <div
//             className="text-gray-400  w-full float-right bg-slate-100 overflow-y-auto"
//             style={{ width: "82%" }}
//           >
//             {component}
//             <div className="absolute !bottom-0 !bg-slate-200 shadow shadow-red-400 opacity-95 trans rounded p-2 !right-0 m-1 text-xl"
//             >
//               Powered By ERP
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Layout;

import React from "react";
import Header from "../shared/Header";
import Sidebar from "../shared/Sidebar";
import "../index.css";

const Layout = ({ component }) => {
  return (
    <div className="flex h-screen w-full flex-col overflow-hidden bg-slate-100">
      {/* Top bar */}
      <header className="z-50 shrink-0 bg-gradient-to-r from-[#020028] via-[#01004b] to-[#020078] shadow-md">
        <Header />
      </header>

      {/* Body */}
      <div className="flex min-h-0 flex-1">
        {/* Sidebar */}
        <aside className="z-30 hidden w-[18%] min-w-[220px] max-w-[280px] shrink-0 overflow-y-auto border-r border-slate-200 bg-white shadow-sm md:block">
          <Sidebar />
        </aside>

        {/* Main content */}
        <main className="relative min-w-0 flex-1 overflow-y-auto bg-slate-100 text-slate-700">
          <div className="min-h-full p-4 pb-14">{component}</div>

          <div className="pointer-events-none fixed bottom-3 right-3 z-40 rounded-md border border-slate-200 bg-white/90 px-3 py-1 text-xs font-medium text-slate-500 shadow-sm backdrop-blur">
            Powered By ERP
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
